// extracted by mini-css-extract-plugin
module.exports = {"app-font-size":"16","breakpoint":"breakpoint","number-lines":"number-lines","dropdown":"ovhtKo","selectedItem":"wBdMOo","menu":"_F_Wwc","menuItem":"HioecO"};